//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
import "../no/IValidator.js";
let d=[[[0,"ValidatorPrintLevel",1,0],[0,"ValidatorVersion",1,0]],[[["validateWireFrame"],"SetWireframeValidation",{},1,0],[["validatePersistentRelations"],"SetPersistentRelationsValidation",{},1,0],[["validateClosedProfiles"],"SetClosedProfilesValidation",{},1,0],[["validateDimensions"],"SetDimensionValidation",{},1,0],[["validateFindMovableCurves"],"SetFindMovableValidation",{},1,0],[["validateSketchChecking"],"SetSketchCheckingValidation",{},1,0],[[],"Destroy",{},0,0],[["status"],"SetValidatorPrintOodStatus",{},1,0]],[]];
SPLM.SketchValidator = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchValidator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;